import { render, staticRenderFns } from "./decennial_choose_course.vue?vue&type=template&id=1410e643&scoped=true"
import script from "./decennial_choose_course.vue?vue&type=script&lang=js"
export * from "./decennial_choose_course.vue?vue&type=script&lang=js"
import style0 from "./decennial_choose_course.vue?vue&type=style&index=0&id=1410e643&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1410e643",
  null
  
)

export default component.exports